import * as React from 'react';

const TicketFillChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            clipRule="evenodd"
            d="M6 4v16h4s0-2.1 2-2.1 2 2.1 2 2.1h4V4h-4s0 2.1-2 2.1S10 4 10 4z"
            fillRule="evenodd"
        />
    </svg>
);

TicketFillChunkySvg.displayName = 'TicketFillChunkySvg';
export default TicketFillChunkySvg;
